<template>
    <NuxtLayout name="main" class="bg-[#F7F6FB]">
        <div
            class="bg-cover bg-no-repeat bg-center pt-[40px] pb-[60px] max-lg:pt-[20px] max-lg:pb-[22px]"
            :style="`background-image: url(${cover});`">
            <div class="font-bold text-center text-[#fec300] text-[56px] leading-[88px] max-xl:text-[40px] max-xl:leading-[58px]">
                Rare Disease Data Center
            </div>
            <div
                class="mt-[20px] mx-auto w-[954px] h-[541px] pt-[20px] pb-[70px] px-[18px] bg-[url(https://rdgta.cdn.cyagen.com/rddc/images/videos/video-box.png)] bg-cover bg-no-repeat bg-center max-xl:w-[692px] max-xl:h-[404px] max-xl:pb-[60px] max-xl:bg-[url(https://rdgta.cdn.cyagen.com/rddc/images/videos/video-box-1920.png)]">
                <video class="w-[100%] h-[100%] object-contain bg-[#000000]" controls muted :src="main"></video>
            </div>
        </div>
        <div class="container pt-[96px] max-xl:pt-[64px] max-lg:pt-[48px]">
            <div class="text-[30px] leading-[46px] text-emphas font-bold">{{ $t("Tutorials") }}</div>
            <div class="mt-[16px] flex">
                <div class="w-[4px] h-[4px] rounded-[50%] bg-main"></div>
                <div class="ml-[4px] w-[52px] h-[4px] rounded-[2px] bg-main"></div>
            </div>
            <!-- * 分类 -->
            <!-- <div class="mt-[40px] flex justify-between items-center max-xl:mt-[32px]">
                <div class="flex">
                    <div
                        class="mr-[16px] bg-[#eeeeee] text-default leading-[48px] rounded-[4px] px-[30px] cursor-pointer hover:bg-main hover:text-white max-xl:leading-[40px] max-xl:px-[24px]"
                        :class="filter === 'all' ? 'bg-main text-white' : ''"
                        v-for="value in filters"
                        @click="methods.acquire(1)">
                        {{ value.label }}
                    </div>
                </div>
                <div class="w-[496px] h-[48px] max-xl:w-[432px] max-xl:h-[40px] max-lg:w-[368px]">
                    <default-search v-model="keywords" width="100%" @search="methods.acquire(1)"></default-search>
                </div>
            </div> -->
            <div class="flex flex-wrap">
                <project-route
                    v-for="value in data"
                    :to="value.url"
                    :title="value.title"
                    class="block mt-[40px] w-[calc((100%-(32px*3))/4)] [&:not(:nth-child(4n+1))]:ml-[32px] group max-xl:w-[calc((100%-(24px*3))/4)] max-xl:[&:not(:nth-child(4n+1))]:ml-[24px] max-xl:mt-[32px]">
                    <div class="relative w-[100%] h-[200px] rounded-[4px] max-xl:h-[176px]">
                        <img class="w-full h-full object-cover" :src="value.cover" />
                        <img
                            class="absolute top-0 right-0 bottom-0 left-0 m-auto w-[72px] h-[72px] max-lg:w-[52px] max-lg:h-[52px]"
                            src="https://rdgta.cdn.cyagen.com/rddc/images/play.webp"
                            alt="" />
                    </div>
                    <div class="mt-[16px] mb-[8px] line-clamp-2 text-emphas font-bold group-hover:text-main max-lg:leading-[22px]">
                        {{ value.title }}
                    </div>
                    <div class="text-default">{{ value.date }}</div>
                </project-route>
            </div>
        </div>
    </NuxtLayout>
</template>
<script lang="ts" setup>
//* 组件属性
import { useComposable } from "./src/composable";

const { refs, methods } = useComposable();
const { cover, data, main } = refs;

//* 页面数据初始化
const origin = await api.server("Videos", "/api/videos", { method: "POST" });
methods.render(origin.value);
</script>
